// 意大利语
const it = {
    next: 'Prossimo',
    error: 'Errore',
    notFound: '404 Non trovato.',
    m: {
        loginTitle: "Sblocca il tuo Power Bank",
        phonePlaceholder: "Numero di cellulare",
        or: 'o',
        emailLogin: 'Continua con l\'email',
        phoneLogin: 'Continua con il telefono',
        quickLogin: 'Continua come ospite',
        loginRequiredTip: 'Accedi prima',
        continueGoogle: "Continua con Google",
        continueApple: "Continua con Apple",
        langBoxTitle: "Scegli una lingua",
        policyAndTerms: "Accetta i <a href='[termsOfServiceUrl]'>Termini di servizio</a> e la <a href='[privacyPolicyUrl]'>Informativa sulla privacy</a> di [brandName].",
        verifyTitle: 'Inserisci il codice a 6 cifre inviato a [phonenumber]',
        verifyEmailTitle: 'Inserisci il codice a 6 cifre inviato a [email]',
        paymentTitle: 'Sblocca il tuo Power Bank',
        resend: "Invia di nuovo il codice",
        emailAddress: "Indirizzo e-mail",
        registerTitle: 'Inserisci le tue informazioni.',
        fNameInput: 'Nome',
        lNameInput: 'Cognome',
        emailInput: 'Indirizzo e-mail',
        birthInput: 'Data di nascita',
        postCodeInput: 'Codice postale',
        billingRate: 'Tariffa',
        unpaidPopupSubtitle: "Hai un ordine non pagato",
        unpaidPopupContent: "Hai un ordine non pagato. Per favore, effettua il pagamento prima di noleggiare di nuovo.",
        payNow: "Paga ora",
        add: "Aggiungi",
        minBalanceTag: 'Min.: {amount}',
        paymentSuccessfulSubtitle: "Pagamento riuscito!",
        paymentSuccessfulContent: "Ora puoi continuare il tuo noleggio!",
        goToRental: "Vai al noleggio",
        repaymentTitle: "Pagamento dell'ordine",
        rentalInformation: "Informazioni sul noleggio",
        selectPayMethod: 'Seleziona il metodo di pagamento',
        selectAuthorizationMethod: 'Seleziona il metodo di autorizzazione',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: 'Saldo',
        creditOrDebit: 'Carta di credito o debito',
        free: 'Gratuito',
        pay: 'Paga',
        confirm: 'Conferma',
        cancel: 'Annulla',
        unlockNow: 'Sblocca Power Bank',
        savePay: 'Salva e paga',
        saveRent: 'Noleggia',
        recharge: 'Ricarica',
        balancePopupTitle: 'Ricarica',
        balancePopupCurrentBalance: 'Saldo attuale: {amount}',
        balancePopupMinRentBalance: 'Saldo minimo per noleggiare: {amount}',
        topUpRent: 'Ricarica',
        topUpSaveCard: 'Ricarica',
        bindPopupTitle: 'Aggiungi carta di pagamento',
        cardPaymentTitle: 'Pagamento con carta',
        preparingTitle: 'Preparando il tuo caricabatterie',
        preparingSubtitle: 'Il tuo Power Bank è in fase di espulsione. Si prega di attendere pazientemente.',
        preparingStationBusySubtitle: 'In attesa che termini l\'espulsione precedente. Attendi.',
        rentalSuccessTitle: 'Successo!',
        rentalFailTitle: 'Fallito!',
        rentalSuccessSubtitle: 'Grazie per aver utilizzato [brandName]. Si prega di restituire il Power Bank dopo l\'uso.',
        rentalNumber: 'Numero di noleggio',
        rentalTime: 'Tempo di noleggio',
        rentalLocation: 'Luogo di noleggio',
        returnTime: "Orario di restituzione",
        returnLocation: "Luogo di restituzione",
        rentalDuration: "Durata del noleggio",
        totalAmount: "Importo Totale",
        paidAmount: "Importo Pagato",
        unpaidAmount: "Importo dovuto",
        currentFee: "Tariffa attuale",
        rentalInfo: 'Informazioni di noleggio',
        rentingTitle: 'Stai utilizzando una power bank [brandName]',
        keepIt: 'Vuoi tenerla? Acquistala ora!',
        findNearby: 'Trova facilmente le stazioni di restituzione vicine: scarica subito la nostra app!',
        nearbyStationTitle: 'Stazioni vicine',
        nearbyStationSearchPlaceholder: 'Cerca stazioni di ricarica vicine',
        nearbyStationRent: 'Noleggia',
        nearbyStationReturn: 'Restituisci',
        nearbyStationAvailable: 'Disponibile',
        nearbyStationEmpty: 'Vuoto',
        nearbyStationLoading: 'Caricamento stazioni vicine...',
        nearbyStationNoStations: 'Nessuna stazione vicina',
        nearbyStationNoRentStations: 'Nessuna stazione vicina per il noleggio',
        nearbyStationNoReturnStations: 'Nessuna stazione vicina per la restituzione',
        nearbyStationSearchAria: 'Cerca stazioni vicine',
        nearbyStationType: 'Tipo di stazione',
        nearbyStationDistance: 'Distanza',
        scanForPowerbank: 'Scansiona Power Bank',
        scanOtherMachine: 'Scan other machine',
        findNearbyReturnableMachines: 'Macchine da restituire',
        scannedMachine: 'Scanned machine',
        scannedMachineWithCode: 'Scanned machine {code}',
        loginViewNearbyRentableMachines: 'Vedi altre macchine nelle vicinanze',
        viewNearbyReturnLocations: 'Macchine da restituire',
        currentMachineUnavailableHint: 'This machine is not available',
        currentMachineAvailableHint: 'La macchina attuale è pronta',
        currentMachineMapDetail: 'You scanned machine {code}. Tap here to return and continue renting from this machine.',
        currentMachineMapAction: 'Tap to continue renting from this machine.',
        machineUnavailableMapDetail: 'You scanned machine {code}, but it cannot be used now. Reason: {reason}. Please scan another machine or use nearby stations on the map.',
        machineUnavailableMapAction: 'Trova una macchina disponibile nelle vicinanze e scansiona il suo codice.',
        mapIslandMachineUnavailableShort: 'Questa macchina non è disponibile',
        mapIslandMachineAvailableActionShort: 'Continua con questa macchina',
        mapIslandMachineUnavailableActionShort: "Scansiona un'altra macchina",
        mapIslandReturnActionShort: 'Torna al noleggio',
        rentingMapIslandTitle: 'Noleggio in corso',
        tapToReturnRentalPage: 'Tocca per tornare al noleggio.',
        scan: 'Scansiona',
        scannerHint: 'Trova il codice QR sulla stazione di ricarica',
        flashlight: 'Torcia',
        mapBack: 'Indietro',
        currentLocation: 'Posizione attuale',
        backToMap: 'Torna alla mappa',
        mapMenu: 'Menu',
        mapMenuYourInfo: 'I tuoi dati',
        mapMenuLanguage: 'Lingua',
        mapMenuHelp: 'Aiuto',
        helpTitle: 'Aiuto',
        helpReportProblem: 'Segnala un problema',
        helpChatWithUs: 'Chatta con noi',
        chatWithUsTitle: 'Chatta con noi',
        chatContactMethods: 'Metodi di contatto',
        reportProblemTitle: 'Segnala un problema',
        reportDeviceCode: 'Codice dispositivo',
        reportScanQrCode: 'Scansiona il QR della macchina',
        reportDeviceCodePlaceholder: 'Scansiona il QR della macchina o inserisci l’ID del dispositivo',
        reportProblemType: 'Problema',
        reportProblemTypeAria: 'Tipo di problema',
        reportProblemPowerBankNotEjected: 'Power bank non espulso',
        reportProblemCannotChargeDevice: 'Non carica il dispositivo',
        reportProblemOrderNotEnded: 'Ordine non terminato',
        reportProblemCableDamagedLost: 'Cavo danneggiato/smarrito',
        reportProblemOther: 'Altro',
        reportTakePicture: 'Carica immagine',
        reportChooseOrTakePicture: 'Carica immagine',
        reportRemovePicture: 'Rimuovi foto',
        reportDescribeProblem: 'Descrivi il problema',
        reportDescriptionPlaceholder: 'Inserisci una descrizione',
        reportFieldRequired: 'Obbligatorio',
        reportFieldOptional: 'Facoltativo',
        reportSubmit: 'Invia',
        reportSubmittedSuccessfully: 'Inviato con successo',
        mapMenuLogin: 'Accedi',
        mapMenuLogout: 'Esci',
        mapMenuLogoutSuccess: 'Disconnesso',
        mapMenuLoadingProfile: 'Caricamento profilo...',
        mapMenuLogoutConfirmTitle: 'Uscire?',
        mapMenuLogoutConfirmContent: 'Dovrai accedere di nuovo prima di noleggiare.',
        profileTitle: 'Profilo',
        profileSave: 'Salva',
        profileNoChanges: 'Aggiorna almeno un campo con un valore.',
        profileDeleteAccount: 'Elimina',
        profileDeleteConfirmTitle: 'Eliminare account?',
        profileDeleteConfirmContent: 'Tutti i dati del tuo account verranno eliminati in modo permanente e verrai disconnesso dopo l eliminazione.',
        closeScanner: 'Chiudi scanner',
        directions: 'Indicazioni',
        call: 'Chiama',
        cabinet: 'Stazione',
        addressUnavailable: 'Indirizzo non disponibile',
        open: 'Aperto',
        closed: 'Chiuso',
        opens: 'Apre',
        closes: 'Chiude',
        hoursUnavailable: 'Orari non disponibili',
        mapUnavailable: 'Mappa non disponibile',
        googleMapsKeyNotConfigured: 'La chiave di Google Maps non è configurata',
        googleMapsLoadFailed: 'Caricamento di Google Maps non riuscito',
        retry: 'Riprova',
        mapLoading: 'Caricamento della mappa...',
        mapReloading: 'Ricaricamento della mappa...',
        cameraUnavailable: 'La fotocamera non è disponibile in questo browser',
        cameraPermissionDenied: 'Autorizzazione fotocamera negata',
        cameraStartFailed: 'Avvio fotocamera non riuscito',
        flashlightUnsupported: 'La torcia non è supportata su questo dispositivo',
        flashlightSwitchFailed: 'Cambio torcia non riuscito',
        invalidQrCode: 'Formato codice QR non valido',
        noon: 'Mezzogiorno',
        weekdayMonday: 'Lunedì',
        weekdayTuesday: 'Martedì',
        weekdayWednesday: 'Mercoledì',
        weekdayThursday: 'Giovedì',
        weekdayFriday: 'Venerdì',
        weekdaySaturday: 'Sabato',
        weekdaySunday: 'Domenica',
        weekdayMon: 'Lun',
        weekdayTue: 'Mar',
        weekdayWed: 'Mer',
        weekdayThu: 'Gio',
        weekdayFri: 'Ven',
        weekdaySat: 'Sab',
        weekdaySun: 'Dom',
        orderDeatil: 'Dettagli dell\'ordine',

        subsTitle: 'Seleziona Piano',
        default: 'Predefinito',
        subscribeAndSave: 'Abbonamento e salvataggio',
        autoRenew: 'Rinnovo automatico',
        reachLimit: 'Limite di utilizzo raggiunto',
        paymentAuthorizationTitle: 'Autorizzazione di pagamento',
        paymentAuthorizationRequired: 'Autorizzazione di pagamento richiesta',
        paymentAuthorizationDesc1: '',
        paymentAuthorizationDesc2: 'L’autorizzazione è richiesta se il noleggio potrebbe superare il tuo piano o se non è collegato alcun metodo di pagamento per eventuali costi aggiuntivi.',
        paymentAuthorizationDesc3: 'Verrà effettuato un addebito temporaneo di [amount]. Sarà interamente sbloccato dopo la restituzione se non si applicano costi aggiuntivi; in caso contrario, il saldo restante verrà rimborsato dopo aver detratto eventuali costi extra.',
        paymentAuthorizationDesc4: 'Seleziona uno dei metodi di autorizzazione seguenti per questo noleggio.',

        totalCost: 'Costo totale',
        returnSuccessTitle: 'Restituzione completata!',
        returnSuccessSubtitle: 'Grazie per aver utilizzato [brandName].',
        rentAgain: 'Noleggia di nuovo',
        guestLoginTips: 'Questa funzione richiede un account formale. La modalità ospite non è disponibile. Vorresti accedere?',
        stationNotFoundTitle: "Station Not Found",
        stationNotFound: "Please try scanning the code again.",
        stationNotSetUpTitle: "Station Not Set Up",
        stationNotSetUp: "Please contact the administrator for assistance, or check other nearby stations.",
        stationOfflineTitle: "Station Offline",
        stationOffline: "Please check if the power cable is properly connected, or try unplugging and re-plugging it.",
        stationBusyTitle: "Station Busy",
        stationBusy: "The station is currently processing the rental task. Please wait a moment and try again.",
        powerBanksUnavailableTitle: "Power Banks Unavailable",
        powerBanksUnavailable: "Power banks are temporarily unavailable due to a technical issue. Please try again later or check another nearby station.",
        noPowerBanksAvailableTitle: "No Power Banks Available",
        noPowerBanksAvailable: "Please check another nearby station.",
        serverErrorTitle: "Server Error",
        serverError: "Please try again later, or contact the administrator for assistance.",
    },
    tMsg: {
        agreePolicy: `Accetta [brandName]’s l'Informativa sulla privacy e i Termini e condizioni`,
        errorTel: 'Inserisci un numero di telefono corretto',
        sendSuccess: 'Inviato con successo',
        inputAll: 'Si prega di compilare tutte le informazioni richieste',
        wrongEmail: 'Formato email errato',
        wrongBirthday: 'Inserisci la tua data di nascita nel formato corretto',
        initPayFail: 'Il pagamento iniziale non è riuscito',
        bindTimeout: 'Timeout di collegamento della carta, riprova',
        bindSuccess: 'Carta collegata con successo',
        subscriptionSuccess: 'Abbonamento acquistato con successo',
        bindFailed: 'Collegamento della carta non riuscito',
        paymentFailed: 'Pagamento non riuscito',
        loginError: 'Errore di accesso',
        paymentMethodNotSupported: 'Metodo di pagamento non supportato',
    },
    bRule: {
        priceDesc: '[price]',
        priceTimeDesc: '/[price_time] minuti',
        freeTimeDesc: '[free_time] minuti gratuiti',
        flatFeeDesc: '[flat_fee] tassa fissa per i primi [flat_fee_time] minuti',
        lowLimitDesc: 'Tariffa minima: [low_limit]',
        topLimitDesc: 'Tariffa massima giornaliera: [top_limit]',
        preAuthDesc: '[pre_auth_amount] sarà pre-autorizzato sul tuo metodo di pagamento',
        depositDesc: 'Se non restituito entro [maximum_rental_time] ore, verrà addebitato [deposit], e la power bank ti appartiene',
        ruleError: 'Errore nella regola',
        noneRuleDesc: 'Nessuna regola',
        taxIncluded: 'Tasse incluse',
        taxIncludedWithRate: 'Include il [tax]% di tasse'
    },
    subscriptionType: {
        1: 'Gratuito [value] minuti per periodo di abbonamento',
        2: 'Gratuito [value] minuti al mese',
        3: 'Gratuito [value] minuti a settimana',
        4: 'Gratuito [value] minuti al giorno',
        6: 'Gratuito [value] volte per periodo di abbonamento',
        7: 'Gratuito [value] volte al mese',
        8: 'Gratuito [value] volte a settimana',
        9: 'Gratuito [value] volte al giorno',
        unlimited: 'illimitato',
        unlimitedRentals: 'Noleggi illimitati gratuiti per periodo di abbonamento',
        durationLimit: 'Fino a [limit] minuti di noleggio gratuito per noleggio. Poi [price] per [price_time] minuti',
        maxLimit: ', massimo [top_limit] al giorno',
    },
    subscriptionTitleTypes: {
        1: '[value] minuti per periodo di abbonamento',
        2: '[value] minuti al mese',
        3: '[value] minuti a settimana',
        4: '[value] minuti al giorno',
        6: '[value] volte per periodo di abbonamento',
        7: '[value] volte al mese',
        8: '[value] volte a settimana',
        9: '[value] volte al giorno',
        unlimited: 'Illimitato',
        unlimitedRentals: 'Noleggi illimitati per periodo di abbonamento',
    },
    subscriptionInfo: {
        period: 'Periodo: [start] - [end]',
        usedShort: '([used]/[total] utilizzato)',
        usage: 'Utilizzo: [total] in totale, [used] utilizzato, [remaining] rimanente',
        usageUnlimited: 'Utilizzo: illimitato',
        autoRenew: 'Rinnovo automatico: [value]',
        autoRenewTrue: 'Sì',
        autoRenewFalse: 'No',
    },
    time: {
        day: 'giorno | giorni',
        hour: 'ora | ore',
        minute: 'minuto | minuti',
        second: 'secondo | secondi',
        month: 'mese | mesi',
        year: 'anno | anni'
    },
    eMsg: {
        30001: 'Human verification failed',
        500: "errore di rete",
        1000: "processo fallito",
        30022: "Inserisci il tuo numero di telefono nel formato corretto",
        30128: "Codice di verifica inviato troppe volte. Per favore riprova più tardi.",
        30129: "Impossibile inviare il codice di verifica",
        //
        30101: 'Il codice di verifica non è corretto o non è più valido',
        // 租借
        50101: "Stazione non trovata",
        50105: "Hai un ordine in sospeso",
        50106: "La stazione è attualmente offline",
        50108: "Al momento non ci sono power bank disponibili",
        50109: "Problema del power bank non riuscito. Per favore riprova più tardi.",
        50113: 'Questa stazione richiede un account',
        50114: 'Gli ospiti non possono usare questa funzione. Accedi',
        50111: 'Metodo di pagamento non valido',
        50305: 'Metodo di pagamento non valido',
        80411: 'Impossibile aggiungere il metodo di pagamento',
        50103: 'Nessun metodo di pagamento valido',
        50206: 'Il pagamento del tuo ultimo ordine non è riuscito. Aggiorna il tuo metodo di pagamento.',
    }
}
export default it
